module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanBadger_j_erythristic.285f605a.png";